define([
  "marionette",
  "backbone",
  "jquery",
  "messaging/messenger",
  "./engineKbModalView",
], function (Marionette, Backbone, $, Messenger, EngineKbModalView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "engineKbModal";
      this.region = options.region;
    },
    show: function (options) {
      options = options || {};
      this.engines = options.engines;
      this.engineKbs = options.engineKbs;
      this.kbs = options.kbs;
      this.model = new Backbone.Model({
        engines: this.engines,
        kbs: new Backbone.Collection(),
        selectedEngine: null,
        selectedKb: null,
      });

      this.view = new EngineKbModalView.view({
        model: this.model,
      });
      this.view.on("cancel", this._onCancel, this);
      this.view.on("done", this._onDone, this);
      this.view.on("engine:select", this._onEngineSelect, this);
      this.view.on("kb:select", this._onKbSelect, this);
      this.view.on("show", this._onShow, this);

      this.showRegion(this.view);
    },
    _filterKbs: function (engine) {
      const engineId = engine.get("engineId");
      const kbSet = new Set();
      this.engineKbs.forEach(function (engineKb) {
        if (engineKb.get("engineId") == engineId) {
          kbSet.add(engineKb.get("kbId"));
        }
      });
      const filteredKbs = new Backbone.Collection();
      this.kbs.forEach(function (kb) {
        if (!kbSet.has(kb.get("kbId"))) {
          filteredKbs.add(kb.clone());
        }
      });
      this.model.set("kbs", filteredKbs);
    },
    _onCancel: function () {
      Messenger.vent.trigger("close:modal");
    },
    _onDone: function () {
      const selectedEngine = this.model.get("selectedEngine");
      this.view.clearErrors();
      if (!selectedEngine) {
        this.view.showEngineError($.t("admin.engineAdmin.engineRequired"));
        return;
      }
      const selectedKb = this.model.get("selectedKb");
      if (!selectedKb) {
        this.view.showKbError($.t("admin.engineAdmin.kbRequired"));
        return;
      }
      const engineKb = this.engineKbs.addItem(selectedEngine, selectedKb);
      engineKb.saveModel({
        success: () => {
          engineKb.dirty = false;
          Messenger.vent.trigger("close:modal");
        },
      });
    },
    _onEngineSelect: function (data) {
      const engineId = data.id;
      const selectedEngine = this.engines.get(engineId);
      this.model.set("selectedEngine", selectedEngine);
      this.model.set("selectedKb", null);
      this._filterKbs(selectedEngine);
      this.view.enableKb();
      this.view.disableDoneButton();
    },
    _onKbSelect: function (data) {
      const kbId = data.id;
      const selectedKb = this.kbs.get(kbId);
      this.model.set("selectedKb", selectedKb);
      this.view.enableKb();
      this.view.enableDoneButton();
    },
    _onShow: function () {
      this.view.disableDoneButton();
      this.view.disableKb();
    },
  });
});
